<script >
    import UploadIco from '../icons/upload.svelte'
    import { createEventDispatcher } from 'svelte'

    const dispatch = createEventDispatcher()

    function onChange(ev) {
        const files = ev.target.files
        if (!files.length) {
            return
        }
        dispatch('change', {files})
    }
</script>

<style lang="scss">
    .input-drag {
        position: relative;
        background: #2C322F;
        border-radius: 20px;
        padding: 10px;
        cursor: pointer;
        .in {
            border-radius: 20px;
            border: 1px dashed #4D5250;
            padding-top: 38px;
            text-align: center;
            height: 180px;
            .text1 {
                font-family: Roboto;
                font-size: 16px;
                color: #FFFFFF;
                letter-spacing: 0.05px;
                text-align: center;
                line-height: 40px;
            }
            .text2 {
                font-family: Roboto;
                font-weight: 300;
                font-size: 13px;
                color: #808683;
                letter-spacing: 0.15px;
                text-align: center;
                line-height: 21px;
                max-width: 350px;
                margin: 0 auto;
            }
        }
        input {
            top: 0;
            left: 0;
            position: absolute;
            opacity: 0;
            right: 0;
            bottom: 0;
            cursor: pointer;
            width: 100%;
        }
    }
</style>

<label class="input-drag">
    <div class="in">
        <UploadIco />
        <div class="text1">Choose a file or drag it here...</div>
        <div class="text2">Select multiple files from your computer (holding „shift key”)
                           or just click to upload documents.</div>
    </div>
    <input on:change={onChange} type="file" multiple>
</label>
